import { motion } from "framer-motion";
import SectionHeading from "../../SectionHeading";
import { fadeUp, revealOnce, stagger } from "../../motion";
import "../../css/Credentials.css";

const CERTIFICATIONS = [
  {
    issuer: "Microsoft",
    title: "Microsoft Certified",
    detail: "Azure & endpoint management fundamentals",
  },
  {
    issuer: "ISC2",
    title: "ISC2 Certified",
    detail: "Certified in Cybersecurity (CC)",
  },
  {
    issuer: "CompTIA",
    title: "CompTIA A+",
    detail: "IT support & hardware fundamentals",
  },
];

const EXPERTISE = [
  "Firewall configuration & management",
  "Switching & routing",
  "Server setup & administration",
  "Active Directory & Group Policy",
  "Network & information security",
  "Endpoint management (Intune, Endpoint Central)",
  "Backup & disaster recovery",
  "Virtualization & cloud (Azure)",
];

const TOOL_GROUPS = [
  {
    label: "Networking & Security",
    tools: ["Cisco", "FortiGate", "pfSense", "Sophos", "UniFi", "Palo Alto"],
  },
  {
    label: "Servers & Virtualization",
    tools: ["Windows Server", "VMware vSphere", "Hyper-V", "Linux", "Active Directory"],
  },
  {
    label: "Endpoint & Identity",
    tools: ["Microsoft Intune", "Endpoint Central", "SCCM", "Entra ID", "Group Policy"],
  },
  {
    label: "Cloud & Productivity",
    tools: ["Microsoft Azure", "Microsoft 365", "Google Workspace", "Odoo ERP"],
  },
  {
    label: "Monitoring & ITSM",
    tools: ["Veeam", "Zabbix", "Grafana", "Jira", "Freshservice", "Topiadesk"],
  },
];

const CheckIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" aria-hidden="true">
    <path
      d="m5 13 4 4L19 7"
      stroke="currentColor"
      strokeWidth="2.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const Credentials = () => {
  return (
    <section className="section credentials">
      <div className="container">
        <SectionHeading
          eyebrow="Certifications & Expertise"
          title="Certified and battle-tested"
          subtitle="Industry certifications backed by hands-on experience running real infrastructure."
        />

        <div className="credentials__layout">
          <motion.div
            className="credentials__certs"
            variants={stagger}
            {...revealOnce}
          >
            {CERTIFICATIONS.map((cert) => (
              <motion.article
                key={cert.title}
                className="cert-badge"
                variants={fadeUp}
              >
                <span className="cert-badge__issuer">{cert.issuer}</span>
                <h3 className="cert-badge__title">{cert.title}</h3>
                <p className="cert-badge__detail">{cert.detail}</p>
              </motion.article>
            ))}
          </motion.div>

          <motion.div
            className="credentials__expertise"
            variants={fadeUp}
            {...revealOnce}
          >
            <h3 className="credentials__expertise-title">Core expertise</h3>
            <ul>
              {EXPERTISE.map((item) => (
                <li key={item}>
                  <span className="credentials__check">
                    <CheckIcon />
                  </span>
                  {item}
                </li>
              ))}
            </ul>
          </motion.div>
        </div>

        {/* Enterprise tools & platforms */}
        <motion.div
          className="credentials__tools"
          variants={fadeUp}
          {...revealOnce}
        >
          <div className="credentials__tools-head">
            <h3 className="credentials__tools-title">Tools &amp; platforms</h3>
            <p className="credentials__tools-text">
              Enterprise systems I deploy, administer, and support day to day —
              across networking, infrastructure, identity, cloud, and IT
              operations.
            </p>
          </div>
          <div className="credentials__tools-grid">
            {TOOL_GROUPS.map((group) => (
              <div key={group.label} className="tool-group">
                <span className="tool-group__label">{group.label}</span>
                <ul className="tool-group__chips">
                  {group.tools.map((tool) => (
                    <li key={tool}>{tool}</li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default Credentials;
